module.exports = __webpack_public_path__ + "img/js4.88f02461.png";